import React from "react";
import "./notfound.css";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const UnAuthorized = () => {
  const navigate = useNavigate();
  const { userRole } = useSelector((state) => state.auth);
  const handleGoHome = () => {
    if (userRole === "ADMIN") {
      navigate("/");
    } else if (userRole === "FAHRER") {
      navigate(`/`);
    } else if (userRole === "GAST") {
      navigate("/personalbogen");
    } else {
      navigate("/login");
    }
  };
  return (
    <div className="not-found-container text-white text-center d-flex align-items-center justify-content-center">
      <Row>
        <Col className="not-found-text">
          <h1 className="display-1 font-weight-bold">401</h1>
          <p className="lead">UNAUTHORIZED</p>
          <div className="not-found-button">
            <Button
              variant="primary"
              className="btn-not-found"
              onClick={handleGoHome}
            >
              GO BACK HOME
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UnAuthorized;
